/** Get Summary Dashboard data */
export const ADD_CAM_API_SUCCESS = "ADD_CAM_API_SUCCESS";
export const ADD_CAM_API_FAIL = "ADD_CAM_API_FAIL";
export const GET_ADD_CAM_DATA = "GET_ADD_CAM_DATA";
